import { render, staticRenderFns } from "./comparison-table.vue?vue&type=template&id=fc097c84&scoped=true"
import script from "./comparison-table.vue?vue&type=script&lang=js"
export * from "./comparison-table.vue?vue&type=script&lang=js"
import style0 from "./comparison-table.vue?vue&type=style&index=0&id=fc097c84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc097c84",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HIcon: require('/home/runner/work/frontpages/frontpages/component-library/src/components/atoms/icons/h-icon.vue').default})
